import type { ProductGroupsApiType } from '@/components/OrderWizard/Contexts/OrderContainersContext/ProductGroups/useProductGroups'
import { ManifoldGroup } from '@components/_SiteWide/TankDisplay/ManifoldGroup'
import { TankProductRow } from '@components/_SiteWide/TankDisplay/TankProductRow'
import { Texto } from '@gravitate-js/excalibrr'
import { startCase } from 'lodash'

type StoreDetailProductsProps = {
  rundownToggled?: boolean
  store: Gravitate.Site
  selectedTank?: Gravitate.Tank
  setSelectedTank: (tank: Gravitate.Tank | undefined) => void
  selectedManifold?: Gravitate.Site['grouped_tanks'][number]
  setSelectedManifold: (manifold: Gravitate.Site['grouped_tanks'][number] | undefined) => void
  addFunction?: (tank: Gravitate.Tank) => void
  disabled?: boolean
  visibleTankIds: number[]
  currentEntryMode?: 'by_compartment' | 'by_product'
  productGroupsApi?: ProductGroupsApiType
}

export function StoreDetailProducts({
  rundownToggled,
  store,
  selectedTank,
  setSelectedTank,
  selectedManifold,
  setSelectedManifold,
  addFunction,
  disabled,
  visibleTankIds,
  currentEntryMode,
  productGroupsApi,
}: StoreDetailProductsProps) {
  if (!store.tanks) return null
  const callInSite = store.monitoring_strategy === 'No Readings (Call-In)'

  return (
    <div className='store-details-products-container h-100 bg-1'>
      {store.grouped_tanks.map((group, i) => {
        return (
          <TankGroup
            key={i}
            group={group}
            count={store.grouped_tanks.length}
            selectedTank={selectedTank}
            setSelectedTank={setSelectedTank}
            selectedManifold={selectedManifold}
            setSelectedManifold={setSelectedManifold}
            addFunction={addFunction}
            disabled={disabled}
            rundownToggled={rundownToggled}
            callInSite={callInSite}
            visibleTankIds={visibleTankIds}
            currentEntryMode={currentEntryMode}
            productGroupsApi={productGroupsApi}
          />
        )
      })}
    </div>
  )
}

function TankGroup({
  rundownToggled,
  group,
  count,
  selectedTank,
  setSelectedTank,
  selectedManifold,
  setSelectedManifold,
  addFunction,
  disabled,
  visibleTankIds,
  callInSite,
  currentEntryMode,
  productGroupsApi,
}) {
  return (
    <>
      {(count > 1 || group.type.toLowerCase() === 'carrier') && (
        <div className='bg-2'>
          <Texto className='py-1 px-3' category='h5'>{`${startCase(group.name)} ${startCase(group.type)}`}</Texto>
        </div>
      )}
      {group.tanks
        .filter((tank) => !tank.manifold_id && visibleTankIds?.includes(tank.tank_id))
        .map((tank) => {
          return (
            <TankProductRow
              rundownToggled={rundownToggled}
              key={tank.tank_id}
              tank={tank}
              isSelected={tank.tank_id === selectedTank?.tank_id && tank.store_number === selectedTank.store_number}
              setSelectedTank={setSelectedTank}
              addFunction={addFunction && (() => addFunction(tank))}
              disabled={disabled}
              callInSite={callInSite}
              currentEntryMode={currentEntryMode}
              productGroupsApi={productGroupsApi}
            />
          )
        })}
      {group.manifold_tanks.map((manifold, i) => {
        if (manifold.tanks.some((tank) => visibleTankIds.includes(tank.tank_id))) {
          return (
            <ManifoldGroup
              rundownToggled={rundownToggled}
              key={i}
              selectedManifold={selectedManifold}
              setSelectedManifold={setSelectedManifold}
              selectedTank={selectedTank}
              manifold={manifold}
              setSelectedTank={setSelectedTank}
              addFunction={addFunction}
              disabled={disabled}
              visibleTankIds={visibleTankIds}
              callInSite={callInSite}
              currentEntryMode={currentEntryMode}
              productGroupsApi={productGroupsApi}
            />
          )
        }
      })}
    </>
  )
}
